import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UserData } from 'API';
export interface ImposterState {
  imposterId: string;
  isAdmin: boolean;
  authenticatedUser: Partial<UserData>;
  fakeUser: Partial<UserData>;
  isReadNotifications: boolean;
}

const initialState: ImposterState = {
  imposterId: '',
  isAdmin: false,
  authenticatedUser: {},
  fakeUser: {},
  isReadNotifications: true,
};

export const imposterSlice = createSlice({
  name: 'imposter',
  initialState,
  reducers: {
    setFakeUser: (
      state: ImposterState,
      action: PayloadAction<Partial<UserData>>
    ) => {
      state.fakeUser = action.payload;
    },
    setUser: (
      state: ImposterState,
      action: PayloadAction<Partial<UserData>>
    ) => {
      state.authenticatedUser = action.payload;
    },
    setImposterId: (state: ImposterState, action: PayloadAction<string>) => {
      state.imposterId = action.payload;
    },
    setIsAdmin: (state: ImposterState, action: PayloadAction<boolean>) => {
      state.isAdmin = action.payload;
    },
    setIsReadNotifications: (
      state: ImposterState,
      action: PayloadAction<boolean>
    ) => {
      state.isReadNotifications = action.payload;
    },
  },
});

export const {
  setImposterId,
  setIsAdmin,
  setFakeUser,
  setUser,
  setIsReadNotifications,
} = imposterSlice.actions;

export default imposterSlice.reducer;
